import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EcoDocsTitleService } from 'app/services/ecodocs-title.service';
import { Globals } from 'app/services/globals';
import { UserService } from 'app/services/user.service';
import { WopiService } from 'app/services/wopi.service';

@Component({
  selector: 'app-wopi',
  templateUrl: './wopi.component.html',
  styleUrls: ['./wopi.component.scss']
})
export class WopiComponent implements OnInit, AfterViewInit {

  actionName: string;
  extension: string;
  fileID: string;

  wopiURL: string = '';

  constructor(private activatedRoute: ActivatedRoute, private wopiService: WopiService,
              private globals: Globals, public userService: UserService, private ecodocsTitleService: EcoDocsTitleService) {

  }

  ngOnInit(): void {
    window.addEventListener('message', (e) => {
      if (!e.data)
        return;
      // The actual message is contained in the data property of the event.
      var msg = JSON.parse(e.data);

      // The message ID is now a property of the message object.
      var msgId = msg.MessageId;

      // The message parameters themselves are in the Values
      // parameter on the message object.
      var msgData = msg.Values;

      if (msgId == 'File_Rename') {
        this.ecodocsTitleService.setTitle(msgData.NewName, false);
      }
    }, false);

    this.activatedRoute.params.subscribe(params => {
      this.actionName = params['action'];
      this.extension = params['extension'];
      this.fileID = params['fileID'];

      this.wopiService.getFileInfo(+this.fileID).subscribe((result) => {
        this.ecodocsTitleService.setTitle(result.BaseFileName, false);
      });

      this.wopiService.getWopiConfig().subscribe((wopiConfig) => {
        let urlSrc: string = wopiConfig[this.extension][this.actionName]['urlsrc'];
        this.ecodocsTitleService.setFavIconLink(wopiConfig[this.extension][this.actionName]['favIconUrl']);
        let baseURL: string = urlSrc.substring(0, urlSrc.indexOf('<'));
        let urlParams = JSON.parse('{' + urlSrc.substring(urlSrc.indexOf('<')).replace(/</g, '"').replace(/=/g, '":"').replace(/&>/g, '",').replace(/>$/g, '"').replace(/(,)$/, '') + '}');
        
        Object.keys(urlParams).forEach((k) => {
          if (urlParams[k] == 'WOPI_SOURCE') {
            baseURL += k + '=' + encodeURIComponent(this.globals.wopi_files_endpoint + '/' + this.fileID) + '&';
          } else if (urlParams[k] == 'BUSINESS_USER') {
            baseURL += k + '=' + '1' + '&';
          }
        });
        
        Object.keys(this.activatedRoute.snapshot.queryParams).forEach((key) => {
          if (key.startsWith('wd')) {
            baseURL += key + '=' + this.activatedRoute.snapshot.queryParams[key] + '&';
          }
        });

        // remove wdPreviousSession & wdPreviousCorrelation
        window.history.replaceState(null, null, window.location.href.replace(/[?|&](wdPreviousSession=[^\&]+[&]*)/, '').replace(/[?|&](wdPreviousCorrelation=[^\&]+[&]*)/, ''));

        this.wopiURL = baseURL;

        var frameholder = document.getElementById('officeframeholder');
        var office_frame = document.createElement('iframe');
        office_frame.name = 'office_frame';
        office_frame.id = 'office_frame';
  
        // The title should be set for accessibility
        office_frame.title = 'Office Frame';
  
        // This attribute allows true fullscreen mode in slideshow view
        // when using PowerPoint's 'view' action.
        office_frame.setAttribute('allowfullscreen', 'true');
  
        // The sandbox attribute is needed to allow automatic redirection to the O365 sign-in page in the business user flow
        office_frame.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation allow-popups-to-escape-sandbox');
        frameholder.appendChild(office_frame);
  
        // give a chance to reflect changes
        setTimeout(() => {
          (document.getElementById('office_form') as any).submit();  
          office_frame.contentWindow.postMessage({
            "MessageId": "Host_PostmessageReady",
            "SendTime": 1329014075000,
            "Values": { }
          }, location.origin);
        }, 1);
        
      });
    });
  }

  ngAfterViewInit() {
    
  }
}
